import CssBaseline from "@mui/material/CssBaseline";
import { router } from "Routes";
import { persistor, store } from "app/store";
import { AuthProvider } from "contexts/Authorization/AuthProvider";
import { I18nProvider } from "contexts/I18n/I18nProvider";
import { IdleCheckerProvider } from "contexts/IdleChecker/IdleCheckerProvider";
import { SWRConfigProvider } from "contexts/SWR/SWRConfigProvider";
import { OLThemeProvider } from "contexts/Theme/ThemeProvider";
import { ToastProvider } from "contexts/Toast/ToastProvider";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

export function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <CssBaseline />
        <SWRConfigProvider>
          <OLThemeProvider>
            <ToastProvider>
              <AuthProvider>
                <I18nProvider>
                  <IdleCheckerProvider>
                    <RouterProvider router={router} />
                  </IdleCheckerProvider>
                </I18nProvider>
              </AuthProvider>
            </ToastProvider>
          </OLThemeProvider>
        </SWRConfigProvider>
      </PersistGate>
    </Provider>
  );
}
